export default __webpack_public_path__ + "media/trail/icons-buttons-print-7ad3e478.svg";